

import VesselMonitoringSingleBay from "./VesselMonitoringSingleBay.vue";

export default {
  components: {
    VesselMonitoringSingleBay
  },
  props: {
    vesselHatch: {
    },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
  },
  mounted() {
  }
}
